export default "__VITE_ASSET__B8nY_leZ__"